import React, { useEffect, useState } from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import { MdCheck, MdOutlineCopyAll } from "react-icons/md";
import ErrorMessage from "../../Components/ErrorMessage";
import { TbReload } from "react-icons/tb";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import { xcode } from "react-syntax-highlighter/dist/esm/styles/hljs";
import InfoInstallationModal from "../InfoInstallationModal";

const REACT_APP_PROPERTY_ENVIRONMENT = process.env.REACT_APP_PROPERTY_ENVIRONMENT;

const PropInstallation = ({
    account_id,
    org_id,
    property_id,
    domain,
    site_id,
    fetchData,
    errorMessage,
    openInfoInstallationModal,
    setOpenInfoInstallationModal
}) => {
    const { t } = useLanguage()
    const [copied, setCopied] = useState(false);
    const [copyError, setCopyError] = useState("");

    const [theme, setTheme] = useState(
        document.documentElement.getAttribute("data-theme") || "light"
    );
    

    const copyCode = async () => {
        if (!site_id) {
            setCopyError("Site ID is missing.");
            setCopied(false);
            return;
        }

        const code = `<script
        src="https://property.abstracht.com/${REACT_APP_PROPERTY_ENVIRONMENT}.js"
        data-site-id="${site_id}">
    </script>`;

        try {
            await navigator.clipboard.writeText(code);

            setCopied(true);
            setCopyError("");

            setTimeout(() => {
                setCopied(false);
            }, 3000);
        } catch (error) {
            console.error("Failed to copy installation code:", error);
            setCopyError("Unable to copy. Please copy the code manually.");
            setCopied(false);

            setTimeout(() => {
                setCopyError("");
            }, 3000);
        }
    };


    useEffect(() => {
        const root = document.documentElement;

        const observer = new MutationObserver(() => {
            setTheme(root.getAttribute("data-theme") || "light");
        });

        observer.observe(root, {
            attributes: true,
            attributeFilter: ["data-theme"],
        });

        return () => observer.disconnect();
    }, []);

    const syntaxTheme = theme === "dark" ? vscDarkPlus : xcode;

    return (
        <div className="open_frame_body">
            <div className="geo_context_cont">
                <p className="add_new_source_cont_title fade-in">
                    {t.properties.install_tag_title}
                </p>

                <p className="add_new_source_cont_desc fade-in">
                    {t.properties.install_on}{" "}
                    <strong className="add_new_source_cont_title_domain">
                        {domain}
                    </strong>{" "}
                    {t.properties.to_enable}
                </p>

                <div className="property_cont_web">
                    <div className="tag_cont">
                        <div className="tag_header">
                            <button
                                type="button"
                                className={`tag_header_btn ${copied ? "copied" : ""}`}
                                onClick={copyCode}
                            >
                                {copied ? (
                                    <MdCheck />
                                ) : (
                                    <MdOutlineCopyAll />
                                )}
                            </button>
                        </div>

                        <div className="tag_script fade-in">
                            <SyntaxHighlighter
                                language="html"
                                style={syntaxTheme}
                                customStyle={{
                                    background: "transparent",
                                    fontSize: "12px",
                                    fontFamily: "Consolas, Monaco, monospace",
                                    margin: 0,
                                }}
                                codeTagProps={{
                                    style: {
                                        fontFamily: "inherit",
                                    },
                                }}
                            >
                                {`<script
    src="https://property.abstracht.com/${REACT_APP_PROPERTY_ENVIRONMENT}.js"
    data-site-id="${site_id}">
</script>`}
                            </SyntaxHighlighter>
                        </div>

                        <div className="tag_footer">
                            <div className="tag_footer_item fade-in">
                                <div className="custom_cell_status">
                                    <span className="status_dot error"></span>
                                </div>{" "}
                                {t.properties.not_installed}
                            </div>

                            <button
                                className="tag_footer_btn fade-in"
                                onClick={fetchData}
                            >
                                <TbReload />
                            </button>
                        </div>
                    </div>
                </div>

                {copyError && (
                    <p className="copy_error_message fade-in" role="alert">
                        {copyError}
                    </p>
                )}

                <p className="warning_source_message fade-in">
                    {t.properties.tag_warn_one}
                </p>
                <p className="warning_source_message fade-in">
                    {t.properties.tag_warn_two} <a className="here_btn" onClick={() => setOpenInfoInstallationModal(true)}>{t.here}</a>
                </p>

                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>
            </div>
            <InfoInstallationModal
                show={openInfoInstallationModal}
                handleClose={() => setOpenInfoInstallationModal(false)}
                site_id={site_id}
            />
        </div>
    )
}

export default PropInstallation